export default function(state = {}, action) {
  const typeMap = {
    MEGATRON_NATIVE_TILE_LOADING() {
      return {
        isLoading: true,
        megatron_native_tile: action.megatron_native_tile
      };
    },
    MEGATRON_NATIVE_TILE_LOADED() {
      return {
        isLoading: false,
        data: action.megatron_native_tile
      };
    },
    MEGATRON_NATIVE_TILE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.megatron_native_tile.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
